import { BehaviorSubject, Subject } from 'rxjs';
import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../../Lib/AxSystem/AxLoad";
import { AxLimeStone } from "../../../Limestone/AxLimeStone";
import { AxTab } from "../../../Limestone/AxPortlet/AxTab";
import { CompPackOrderTicketValues } from "../../../Models/ComplexPackages/BookingOptions/CompPackOrderTicketValues";
import { BookingTimeSlotInfo } from "../../../Models/ComplexPackages/BookingTimeSlotInfo";
import { ITimeSlot, TimeSlotEntry } from "../../../Models/Reservation/TimeSlot";
import { TimeSlotDay } from "../../../Models/Reservation/TimeSlotDay";
import { TimeSlotKey } from "../../../Models/Reservation/TimeSlotKey";
import { TicketType } from "../../../Models/Tickets/TicketType";
import { ComplexPackageBookingOptions } from "../ComplexPackageBookingOptions";

@ModuleName("ComplexPackageBookingTicketsOptions")
export class ComplexPackageBookingTicketsOptions implements AxInit {
    protected ticketTypes: TicketType[];
    protected datePattern: string;
    protected complexPackageBookingOptions: ComplexPackageBookingOptions;

    public InteractionSubject: BehaviorSubject<Element> = new BehaviorSubject(null);
    public SubmitSubject: Subject<Element> = new Subject<Element>();
    public bookingTimeSlotInfos: BookingTimeSlotInfo[] = [];

    constructor(
        private _AxLimestone = new AxLimeStone(),
        private _AxTab = new AxTab(),
    ) { }

    AxInit(init: initData): void {
        this.datePattern = init.datePattern;
        this.ticketTypes = JSON.parse(init.ticketTypes !== '' ? init.ticketTypes : '[{}]');

        this.complexPackageBookingOptions = AxLoad.GetModule<ComplexPackageBookingOptions>("ComplexPackageBookingOptions");

        this.ticketTypes.forEach((ticketType: TicketType) => this.loadTicket.call(this, ticketType));
    }

    nextTab(): void {
        let activeTab = $('.tv4_contingent__selection-portlet .ax-tabs li.active');
        $('.prod_selection__summary-next').fadeOut('fast');

        this._AxTab.ActivateTab(activeTab.next().attr('data-target'));
    }

    loadTicket(ticketType: TicketType): void {
        const {
            projNr,
            poolNr,
            ticketTypeNr,
            personTypeNr,
            hasTimeSlots,
            packagePositionNr,
        } = ticketType;
        const ticketValues = new CompPackOrderTicketValues(projNr, ticketTypeNr, poolNr, personTypeNr, packagePositionNr, hasTimeSlots);
        const timeSlotDayList: TimeSlotDay[] = [];
        const timeSlotGroupKeyList: number[] = [];
        const ticketsSlotsTag = `#compPack_products_ticket_holder_${ticketType.projNr}_${ticketType.poolNr}_${ticketType.ticketTypeNr}`;
        const $hiddenViewDataHolder = $(ticketsSlotsTag).find('.timeSlots_ViewData');
        const timeSlotsViewData = $($hiddenViewDataHolder).val()?.toString() || '';
        const timeSlotList: TimeSlotEntry[] = JSON.parse(timeSlotsViewData !== '' ? timeSlotsViewData : '[{}]');
        const selector: string = '.tv4_contingent__selection-portlet .ax-tabs';

        if (!ticketType.hasTimeSlots) {
            this.complexPackageBookingOptions.bookingValues.ticketOrderValues.push(ticketValues);
            return;
        }
        if ($(selector).length > 0) {
            this._AxTab.Init(selector);
            $('.prod_selection__selection-next-submit').on('click', () => this.nextTab());
        }

        //call constructor for class methods
        for (let entry of timeSlotList) {
            const { timeSlotKey } = entry;
            entry.timeSlotKey = new TimeSlotKey(timeSlotKey?.timeSlotGroupKey, timeSlotKey?.timeSlotKey1, timeSlotKey?.timeSlotKey2);
        }
        
        this.initTimeSlotListeners(ticketTypeNr, packagePositionNr, ticketValues.selectedTimeSlots, timeSlotList, timeSlotDayList, timeSlotGroupKeyList);

        this.complexPackageBookingOptions.bookingValues.ticketOrderValues.push(ticketValues);

        $('.product_selection__allotment_lang button').on('click', (e) => {
            this.activateLanguage($(e.target).data('langid'));
        });

        this.activateLanguage($('.product_selection__allotment_lang button')?.first()?.data('langid') ?? $('.product_selection__allotment_selection')?.first()?.data('langid') ?? 0);
    }

    initTimeSlotListeners(
        ticketTypeNo: number,
        packagePosNr: number,
        selectedTimeSlots: ITimeSlot[],
        timeSlotList: TimeSlotEntry[],
        timeSlotDayList: TimeSlotDay[],
        timeSlotKeyList: number[],
    ): void {
        //Only Multicontingent stuff
        if ($('.tv4_contingent__selection-header').length > 0) {
            $(`.product_selection__timeSlot_switch`).on('click', (e) => {
                const $currentTarget = $(e.currentTarget);
                const timeSlotGroupKey = Number($currentTarget.attr('data-target'));

                if ($currentTarget.is(':checked')) {
                    const selectedIndex = selectedTimeSlots.findIndex((i) => i.timeSlotKey.timeSlotGroupKey == timeSlotGroupKey);

                    if (selectedIndex > -1) {
                        const tmpSlot = selectedTimeSlots[selectedIndex];
                        const tmpSlotEntryTemp = this.getTimeSlot(tmpSlot.timeSlotKey, timeSlotList);
                        this.selectNearestTimeSlots(tmpSlotEntryTemp, ticketTypeNo, selectedTimeSlots, timeSlotList, timeSlotDayList);
                    }
                } else {
                    $(`.product_selection__timeSlot_danger[data-target="${timeSlotGroupKey}"]`).addClass('d-none');
                }
            });
        }

        for (let slot of timeSlotList) {
            const $timeButton = $('.product_selection__allotment_selection .product_selection__allotment_time-container button'
                + `[data-ticketNo="${ticketTypeNo}"]`
                + `[data-timeSlotGroupKey="${slot.timeSlotKey.timeSlotGroupKey}"]`
                + `[data-timeSlotKey1="${slot.timeSlotKey.timeSlotKey1}"]`
                + `[data-timeSlotKey2="${slot.timeSlotKey.timeSlotKey2}"]`);
            slot.day = moment(slot.date, 'YYYY-MM-DD');
            slot.elem = $timeButton?.get(0);
            const dayData: TimeSlotDay = {
                day: slot.day,
                timeSlotGroupKey: slot.timeSlotKey?.timeSlotGroupKey,
            };
            const selectedTimeSlot = timeSlotDayList.findIndex((timeSlotDay) => (
                timeSlotDay.timeSlotGroupKey == dayData.timeSlotGroupKey && timeSlotDay.day.isSame(slot.day)
            ));
            const groupKey = timeSlotKeyList.findIndex((timeSlotKey)=> timeSlotKey == dayData.timeSlotGroupKey);
            const oldStatus: string = $timeButton.attr('data-contingentstatus');
            let newStatus: string = '';

            if (selectedTimeSlot === -1) {
                timeSlotDayList.push(dayData);
            }
            if (groupKey === -1) {
                timeSlotKeyList.push(dayData.timeSlotGroupKey);
            }

            $timeButton.removeClass(`ax-fill-${oldStatus}-500`);
            $timeButton.removeClass(`ax-outline-${oldStatus}-500`);

            if (slot.availableSlots != 0 && slot.availableSlots >= 1) {
                if ((slot.availableSlots - 1) <= slot.warningThreshold) {
                    newStatus = 'red';
                } else if ((slot.availableSlots - 1) <= slot.limitedThreshold) {
                    newStatus = 'orange';
                } else {
                    newStatus = 'green';
                }
                $timeButton.attr('data-contingentstatus', newStatus);

                if (selectedTimeSlots.filter(x => x.timeSlotKey.equal(slot.timeSlotKey)).length > 0) {
                    $timeButton.addClass(`ax-fill-${newStatus}-500`);
                } else {
                    $timeButton.addClass(`ax-outline-${newStatus}-500`);
                }
            } else {
                $timeButton.removeAttr('data-contingentstatus');

                if (selectedTimeSlots.filter(x => x.timeSlotKey.equal(slot.timeSlotKey)).length > 0) {
                    this.deactivateContingent(slot.timeSlotKey, ticketTypeNo, selectedTimeSlots, timeSlotDayList, timeSlotList);
                }
            }
        }

        this.bookingTimeSlotInfos.push({
            packagePositionNr: packagePosNr,
            requiredTimeSlots: timeSlotDayList
        });

        $('.product_selection__allotment_selection button.ax-chip').on('click', (e) => {
            this.selectionContingent(e.target, ticketTypeNo, selectedTimeSlots, timeSlotList, timeSlotDayList);
        });
    }

    activateLanguage(langID: number): void {
        $(`.product_selection__allotment_lang button`).removeClass('ax-chip--active');
        $(`.product_selection__allotment_lang button[data-langid=${langID}]`).addClass('ax-chip--active');

        $('.product_selection__allotment_selection').addClass('d-none');
        $(`.product_selection__allotment_selection[data-langid=${langID}]`).removeClass('d-none');
    }

    deactivateContingent(
        timeSlotKey: TimeSlotKey,
        ticketTypeNo: number,
        selectedTimeslots: ITimeSlot[],
        timeSlotDayList: TimeSlotDay[],
        timeSlotList: TimeSlotEntry[],
    ): void {
        const index: number = selectedTimeslots.findIndex(x => x.timeSlotKey.equal(timeSlotKey));
        if (index > -1) {
            selectedTimeslots.splice(index, 1);
        }

        $('.product_selection__allotment_selection button'
            + `[data-ticketNo="${ticketTypeNo}"]`
            + `[data-timeSlotGroupKey="${timeSlotKey.timeSlotGroupKey}"]`
            + `[data-timeSlotKey1="${timeSlotKey.timeSlotKey1}"]`
            + `[data-timeSlotKey2="${timeSlotKey.timeSlotKey2}"]`).each((i, el) => {
            const $button: JQuery<Element> = $(el);
            const color: string = $button.attr('data-contingentstatus');
            $button.removeClass(`ax-fill-${color}-500`);
        });

        this.printSelectedContingents(selectedTimeslots, timeSlotDayList, timeSlotList);
    }

    printSelectedContingents(selectedTimeslots: ITimeSlot[], timeSlotDayList: TimeSlotDay[], timeSlotList: TimeSlotEntry[]): void {
        const $template = $('.product_selection__setting_timeslot--entry');
        $(`.product_selection__setting_timeslot`).html('');
        $('.product_selection__setting_timeslot--placeholder').removeClass('d-none');

        for (let timeSlotDay of timeSlotDayList) {
            const isMultiDay: boolean = timeSlotDayList.filter(x => x.timeSlotGroupKey == timeSlotDay.timeSlotGroupKey).length > 1;
            const selectedSlot = selectedTimeslots.filter((timeSlot) => (
                timeSlot.timeSlotKey.timeSlotGroupKey == timeSlotDay.timeSlotGroupKey && timeSlot.day.isSame(timeSlotDay.day)
            ));

            if (selectedSlot.length > 0) {
                const $entry = $template.clone();
                let label = '';
                $(`#tv4_side__selection-tab > div[data-target="${timeSlotDay.timeSlotGroupKey}"] .product_selection__setting_timeslot--placeholder`).addClass('d-none');
                const timeslot = this.getTimeSlot(selectedSlot[0].timeSlotKey, timeSlotList);
                if (isMultiDay) {
                    label += `${timeslot.day.format(this.datePattern)}, `;
                }
                label += timeslot.elem.innerHTML;

                $entry.removeClass('d-none product_selection__setting_timeslot--entry').html(label);
                $(`#tv4_side__selection-tab > div[data-target="${timeSlotDay.timeSlotGroupKey}"] .product_selection__setting_timeslot`).append($entry);
            }
        }
    }

    getTimeSlot(timeSlotKey: TimeSlotKey, timeSlotList: TimeSlotEntry[]): TimeSlotEntry {
        return timeSlotList.find((el) => el.timeSlotKey.equal(timeSlotKey));
    }

    checkSuballotmentQuantity(timeSlotKey: TimeSlotKey, timeSlotList: TimeSlotEntry[]): boolean {
        const sumQuantity: number = 1;
        const subC = this.getTimeSlot(timeSlotKey, timeSlotList);

        return subC?.availableSlots >= sumQuantity;
    }

    selectNearestTimeSlots(
        timeslot: TimeSlotEntry,
        ticketTypeNo: number,
        selectedTimeSlots: ITimeSlot[],
        timeSlotList: TimeSlotEntry[],
        timeSlotDayList: TimeSlotDay[],
    ): void {
        const time = timeslot.time;
        const timeSlotByDay = timeSlotDayList.filter((timeSlot) => (
            timeSlot.timeSlotGroupKey == timeslot?.timeSlotKey.timeSlotGroupKey
                && timeSlot?.day?.format('YYYY-MM-DD') !== timeslot.date
        ));
        let nearestTimeSlot: TimeSlotEntry;
        let alwaysSame = true;

        for (let slotDay of timeSlotByDay) {
            const timeSlotGroupSameDay = timeSlotList.filter((slot) => (
                slot?.timeSlotKey.timeSlotGroupKey == slotDay.timeSlotGroupKey && slot?.day?.isSame(slotDay?.day)
            ));
            let currentOffset = 9999;

            for (let tmpSlot of timeSlotGroupSameDay) {
                let offset = time - tmpSlot.time;
                if (offset < 0) {
                    offset = offset * -1;
                }

                if (offset < currentOffset && this.checkSuballotmentQuantity(tmpSlot.timeSlotKey, timeSlotList)) {
                    nearestTimeSlot = tmpSlot;
                    currentOffset = offset;

                    if (offset == 0) {
                        break;
                    }
                }
            }

            if (currentOffset != 0) {
                alwaysSame = false;
            }

            this.selectionContingent(nearestTimeSlot.elem, ticketTypeNo, selectedTimeSlots, timeSlotList, timeSlotDayList, false);
        }
        $(`.product_selection__timeslot_danger[data-target="${timeslot.timeSlotKey.timeSlotGroupKey}"]`).toggleClass('d-none', alwaysSame);
    }

    selectionContingent(
        e: Element,
        ticketTypeNo: number,
        selectedTimeSlots: ITimeSlot[],
        timeSlotList: TimeSlotEntry[],
        timeSlotDayList: TimeSlotDay[],
        triggerChecks: boolean = true,
    ): void {
        const $elem: JQuery<Element> = $(e);
        const color: string = $elem.attr('data-contingentstatus');
        const timeSlotGroupKey: number = Number($elem.attr('data-timeSlotGroupKey'));
        const timeSlotKey1: string = $elem.attr('data-timeSlotKey1');
        const timeSlotKey2: number = Number($elem.attr('data-timeSlotKey2'));
        const timeSlotKey: TimeSlotKey = new TimeSlotKey(timeSlotGroupKey, timeSlotKey1, timeSlotKey2);
        const checkSuballotmentQuantity = this.checkSuballotmentQuantity(timeSlotKey, timeSlotList);
        const $activeTab = $('.tv4_contingent__selection-portlet .ax-tabs li.active');

        if (checkSuballotmentQuantity) {
            const currentTimeSlot = this.getTimeSlot(timeSlotKey, timeSlotList);
            selectedTimeSlots
                .filter((selected) => (
                    selected?.timeSlotKey.timeSlotGroupKey == timeSlotGroupKey && selected?.day?.isSame(currentTimeSlot.day))
                )
                .forEach((timeSlot) => {
                    const $productSelection = $('.product_selection__allotment_selection button'
                        + `[data-timeSlotGroupKey="${timeSlot.timeSlotKey.timeSlotGroupKey}"]`
                        + `[data-timeSlotKey1="${timeSlot.timeSlotKey.timeSlotKey1}"]`
                        + `[data-timeSlotKey2="${timeSlot.timeSlotKey.timeSlotKey2}"]`);
                    const productSelectionColor: string = $productSelection.attr('data-contingentstatus');
                    $productSelection.removeClass(`ax-fill-${productSelectionColor}-500`).addClass(`ax-outline-${productSelectionColor}-500`);
                });

            const index: number = selectedTimeSlots.findIndex((selected) => (
                selected.timeSlotKey?.timeSlotGroupKey == timeSlotGroupKey && selected?.day?.isSame(currentTimeSlot.day))
            );
            if (index > -1) {
                selectedTimeSlots.splice(index, 1);
            }

            selectedTimeSlots.push({
                timeSlotKey: timeSlotKey,
                day: currentTimeSlot.day,
                time: currentTimeSlot.time
            });

            this.printSelectedContingents(selectedTimeSlots, timeSlotDayList, timeSlotList);
            $elem.removeClass(`ax-outline-${color}-500`).addClass(`ax-fill-${color}-500`);

            const isChecked = $(`.product_selection__timeSlot_switch[data-target="${timeSlotGroupKey}"]`).prop('checked');
            if (isChecked && triggerChecks) {
                this.selectNearestTimeSlots(currentTimeSlot, ticketTypeNo, selectedTimeSlots, timeSlotList, timeSlotDayList);
            }
        }
        
        if ($activeTab.length > 0) {
            if (!$activeTab.is(':last-child')) {
                const configActiveTab = Number($activeTab.attr('data-target'));
                const timeSlotSelected = selectedTimeSlots.filter((timeSlot) => timeSlot.timeSlotKey.timeSlotGroupKey === configActiveTab);
                const timeSlotDay = timeSlotDayList.filter((timeSlot) => timeSlot.timeSlotGroupKey === configActiveTab);
                if (timeSlotSelected.length === timeSlotDay.length) {
                    $('.prod_selection__summary-next').fadeIn('fast');
                }
            } else {
                $('.prod_selection__summary-next').fadeOut('fast');
            }
        }
    }
}

export interface initData {
    ticketTypes: string;
    datePattern: string;
}
